import { ofType } from 'redux-observable';
import {
  AuctionActionCalendarEnum,
  IFetchFiltersAndAuctionCalendarAction
} from '.';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import {
  AuctionMessageEnum,
  AuctionService,
  BidService,
  IAuction,
  ICorridorDetail
} from '../../services';
import {  
  FetchedFiltersAndAuctionCalendarSuccessAction,
  FetchedFiltersAndAuctionCalendarFailedAction,
} from './ActionCreator';
import {
  IApplicationState,
  IAuctionFilters,
} from '..';
import { EMPTY, forkJoin, of } from 'rxjs';

const auctionSerivce = new AuctionService();
const bidService = new BidService();

export const fetchFilterAndAuctionCalendarEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(AuctionActionCalendarEnum.FetchFiltersAndAuctionCalendar),
    withLatestFrom(state$),
    mergeMap(
      ([action, state]: [IFetchFiltersAndAuctionCalendarAction, IApplicationState]) => {
        return bidService.getAllCorridors().pipe(
          switchMap((corridors : ICorridorDetail[]) => {
            if(!action.state?.initialFilters || !state.auction.currentFilters){
              return EMPTY;
            }
            return forkJoin([
              of(corridors),
              of(action.state?.initialFilters),
              of(state.auction.currentFilters),
            ]);
          }),
          switchMap(
            (data: [ICorridorDetail[], IAuctionFilters, IAuctionFilters]) => {
              const response = auctionSerivce.getAuctionCalendar(
                data[0].map((item) => item.corridorKey)
              );
              return forkJoin([response, of(data[0])]);
            }
          ),         
          map(
            (
              response: [
                IAuction[],
                ICorridorDetail[]
              ]
            ) => {            
              return FetchedFiltersAndAuctionCalendarSuccessAction(response[0], response[1]);              
            }
          ),
          catchError((x) => {
            console.error(x);
            return of(
              FetchedFiltersAndAuctionCalendarFailedAction(
                AuctionMessageEnum.UnableToGetAuctionResult
              )
            );
          })
        );
      }
    )
  );
